import React from 'react'
import logo from '../../../assets/desktop-logo.png'
import { useNavigate } from 'react-router-dom';
const EventHeader = () => {
  const navigate = useNavigate();
  return (
    <>
        
  <header class="d-flex justify-content-between align-items-center p-3 bg-white shadow-sm cursor-pointer">
    <img src={logo} alt="logo" class="img-fluid" style={{width: "100px"}} onClick={() => navigate('/')} />
  </header>

    </>
  )
}

export default EventHeader
